function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { spacing, themeLight, icons, breakpoints, radius } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { animation } from '@naf/theme';
import { ArrowForward } from '@styled-icons/material/ArrowForward';
const CardBlock = ({
  advancedImage,
  img,
  title,
  headerTag
}) => /*#__PURE__*/React.createElement(Card, null, (advancedImage || img) && /*#__PURE__*/React.createElement(ImgWrap, null, advancedImage && advancedImage, img && !advancedImage && /*#__PURE__*/React.createElement("img", {
  src: img.src,
  alt: img.alt
})), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(TextContent, null, title && /*#__PURE__*/React.createElement(Header, {
  tag: headerTag,
  variant: TextVariant.CardHeader
}, title)), /*#__PURE__*/React.createElement(StyledArrow, {
  size: 24
})));
export const ImageCard = /*#__PURE__*/forwardRef(({
  advancedImage,
  img,
  title,
  headerTag = 'h3',
  href,
  className,
  target,
  isInternalLink = false,
  linkRef,
  ...rest
}, ref) => {
  if (isInternalLink) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: className,
      ref: ref
    }, rest), /*#__PURE__*/React.createElement(CardBlock, {
      advancedImage: advancedImage,
      img: img,
      title: title,
      headerTag: headerTag
    }));
  }
  return /*#__PURE__*/React.createElement(LinkWrapper, _extends({
    href: href || undefined,
    className: className,
    ref: linkRef,
    target: target
  }, rest), /*#__PURE__*/React.createElement(CardBlock, {
    advancedImage: advancedImage,
    img: img,
    title: title,
    headerTag: headerTag
  }));
});
const StyledArrow = styled(ArrowForward).withConfig({
  displayName: "ImageCard__StyledArrow",
  componentId: "sc-1i2izl8-0"
})(["margin-top:2px;font-size:", ";color:", ";transition:margin ", " 0.4s;"], icons.s, themeLight.typography.defaultText, animation.easeOut || 'ease');
const Content = styled.div.withConfig({
  displayName: "ImageCard__Content",
  componentId: "sc-1i2izl8-1"
})(["display:flex;background-color:", ";padding:", ";width:100%;align-items:center;border-radius:0 0 ", " ", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondary : themeLight.componentColors.cta.secondary, spacing.space24, radius.m, radius.m);
const TextContent = styled.span.withConfig({
  displayName: "ImageCard__TextContent",
  componentId: "sc-1i2izl8-2"
})(["display:inline-flex;flex:1;flex-wrap:wrap;flex-direction:column;align-items:flex-start;"]);
const LinkWrapper = styled.a.withConfig({
  displayName: "ImageCard__LinkWrapper",
  componentId: "sc-1i2izl8-3"
})(["text-decoration:none;"]);
const Card = styled.div.withConfig({
  displayName: "ImageCard__Card",
  componentId: "sc-1i2izl8-4"
})(["display:flex;flex-wrap:wrap;text-decoration:none;color:", ";overflow-x:auto;padding-top:", ";margin-top:-", ";&:visited,&:hover,&:active{color:", ";}&:hover{img{transform:scale(1.02);}", "{margin-right:-", ";}", "{background-color:", ";}}@media (max-width:", "){margin-bottom:", ";}"], ({
  theme
}) => theme.componentColors ? theme.typography.brandText : themeLight.typography.brandText, spacing.space8, spacing.space8, themeLight.typography.brandText, StyledArrow, spacing.space8, Content, ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondaryHover : themeLight.componentColors.cta.secondaryHover, breakpoints.s, spacing.space8);
const ImgWrap = styled.figure.withConfig({
  displayName: "ImageCard__ImgWrap",
  componentId: "sc-1i2izl8-5"
})(["position:relative;width:100%;max-height:100%;padding:0;margin:0;overflow:hidden;flex:none;border-radius:", " ", " 0 0;&:before{display:block;content:'';padding-top:88%;}img{position:absolute;top:0;left:0;height:100%;width:100%;object-fit:cover;transition:transform 0.6s ", ";z-index:1;}"], radius.m, radius.m, animation.easeOut || 'ease');
const Header = styled(Text).withConfig({
  displayName: "ImageCard__Header",
  componentId: "sc-1i2izl8-6"
})(["margin:0;"]);
//# sourceMappingURL=ImageCard.js.map